<template>
  <!-- Première cellule vide pour la colonne fixe -->
  <div class="p-2 bg-white" :style="{ gridColumn: `span 1` }"></div>

  <!-- Pour chaque jour, pour chaque heure générée, on affichera l'heure avec un fond conditionnel -->
  <template v-for="(month, mIndex) in dateArrays.months" :key="'month-' + mIndex">
    <div 
      @click="go_to(month.startDate)"
      :class="[
        'bg-[#1E1017] text-white rounded-2xl p-1 mb-1 truncate h-8 select-none cursor-pointer hover:bg-[#E8535D]',
        { 'ml-1': mIndex !== 0 }
      ]"
      :style="{ gridColumn: `span ${monthSpan(month)}` }"
    >
      {{ formatMonth(month) }}
    </div>
  </template>
    
</template>

<script>

import { inject } from 'vue';

export default{
  props:{
    slotsLength: Number,
  },
  setup(){
    const dateArrays = inject('dateArrays');
    const state = inject('state');
    const checkForViewChange = inject('checkForViewChange');
    return { dateArrays, state, checkForViewChange };
  },
  methods:{
    monthSpan(month){
      return (this.slotsLength * month.days);
    },
    formatMonth(month) {
      const formatter = new Intl.DateTimeFormat('fr-FR', { month: 'long' });
      const date = new Date();
      date.setMonth(month.number); // `month.number` est supposé être le numéro du mois (0-11)

      if(['Jour', 'Semaine'].includes(this.state.selectedView.name)){
        return formatter.format(date).charAt(0).toUpperCase() + formatter.format(date).slice(1) + ' ' + month.year;
      }

      return formatter.format(date).charAt(0).toUpperCase() + formatter.format(date).slice(1);
    },
    go_to(date){
      this.state.startDate = new Date(date);
      this.state.endDate = new Date(new Date(date).setDate(new Date(date).getDate() + 32));
      this.checkForViewChange()
    }
  }
}

</script>